// Fallback landing content — mirrors backend DEFAULT_LANDING (public_routes.py).
// Used so the public site still renders its marketing shell when the API is
// unreachable (cold backend, network error) instead of hanging on "Loading…".
export const LANDING_DEFAULTS = {
  brand_name: "EduPulse",
  brand_sub: "School Network · AP",
  badge: "Admissions open for 2026-27",
  hero_title: "One portal for every school in your",
  hero_highlight: "network.",
  hero_text:
    "Explore schools, apply for admission online, upload certificates and track your application — all from one place. Parents get updates on WhatsApp.",
  hero_image:
    "https://images.unsplash.com/photo-1509062522246-3755977927d7?w=1400&q=80",
  hero_card_title: "OTP-verified admissions",
  hero_card_text: "Secure parent verification",
  directory_title: "Schools on EduPulse",
  directory_subtitle: "Select a school to view its portal & apply",
  features_title: "Built for parents, teachers and school offices",
  features: [
    {
      icon: "BookOpenCheck",
      title: "Online Admissions",
      text: "Apply from home with document upload & OTP-verified parent details.",
    },
    {
      icon: "MessageCircle",
      title: "WhatsApp Updates",
      text: "Fee receipts, absentee alerts and homework straight to parents.",
    },
    {
      icon: "IndianRupee",
      title: "Online Fee Payment",
      text: "Pay via PhonePe from home. Printable receipts, zero paperwork.",
    },
    {
      icon: "Smartphone",
      title: "Parent & Teacher App",
      text: "Progress records, attendance and timetables on your phone.",
    },
  ],
  footer_text: "EduPulse Multi-School ERP. Built for AP School Education (LEAP).",
  contact_email: "",
  contact_phone: "",
  login_kicker: "Multi-School ERP",
  login_title: "Run every school from one command center.",
  login_points: [
    "Online admissions with OTP-verified parents",
    "Fees, receipts & WhatsApp alerts",
    "Attendance, exams & printable report cards",
  ],
  login_stats: [
    { value: "10K+", label: "Students" },
    { value: "₹4Cr+", label: "Fees managed" },
    { value: "99.9%", label: "Uptime" },
  ],
};
